import { __ } from '@wordpress/i18n';
require('dom-slider');

const { slideToggle } = window.domSlider;

const buttons = document.querySelectorAll('.block-read-more-content__button');

const toggleContent = (e) => {
	e.preventDefault();

	const block = e.currentTarget.closest('.block-read-more-content');

	if (!block) {
		return;
	}

	const content = block.querySelector('.block-read-more-content__content');

	if (!content) {
		return;
	}

	e.currentTarget.classList.toggle('block-read-more-content__button--active');

	e.currentTarget.innerText = e.currentTarget.classList.contains(
		'block-read-more-content__button--active'
	)
		? __('Read Less', 'propel')
		: __('Read More', 'propel');

	slideToggle({
		element: content,
		slideSpeed: 400,
		easing: 'ease-in-out',
	});
};

if (buttons.length) {
	buttons.forEach((button) => {
		button.addEventListener('click', toggleContent);

		button.parentElement.classList.add(
			'block-read-more-content--initialized'
		);
	});
}
